import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Union } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-pap-union-verification',
  templateUrl: 'pap-union-verification.component.html',
  styleUrls: ['./pap-union-verification.component.less', '../../../shared/common.less'],
})

export class PapUnionVerificationComponent implements OnInit {
  @Input() unions: Union[] = [];
  @Input() isExpanded: boolean = false;
  @Output() unionsChange = new EventEmitter<Union[]>();
  @Output() validated = new EventEmitter<boolean>();
  @Output() editRequested = new EventEmitter<void>();

  needPap: boolean = undefined;
  isValidated: boolean = false;

  constructor(
  ) {}
  
  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  onValidate() {
    this.isExpanded = false;
    this.isValidated = true;
    this.validated.emit(true);
  }

  onEdit() {
    this.editRequested.emit();
  }
  
  onUnionChange() {
    this.unionsChange.emit(this.unions);
  }
  
  ngOnInit(): void {
  }
}
